import { AudioPlayContext } from '@/contexts/AudioPlayContext';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { Dispatch, SetStateAction, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogContext } from '..';
import { ScreenContext } from '@/contexts/ScreenContext';
import { getVHByRem } from '@/utils/commonFunc';
import './index.scss';

type DialogHeaderProps = {
    title: string;
    dialogOpen?: Dispatch<SetStateAction<boolean>>;
};

export const DialogHeader = (props: DialogHeaderProps) => {
    const { dialogOpen, title } = props;
    const { t } = useTranslation();
    const { playButtonAudio } = useContext(AudioPlayContext);
    const { extraCloseHandler, resetCloseHandler } = useContext(DialogContext);
    const { isLandscape } = useContext(ScreenContext);

    return (
        <>
            <Grid
                container
                className="dialog-header-container"
                sx={{
                    height: isLandscape ? getVHByRem(2.333) : '2.333rem',
                    fontSize: isLandscape ? getVHByRem(1) : '1rem',
                }}
            >
                <Grid
                    item
                    id="place-hoder"
                    sx={{
                        width: '36px',
                    }}
                />
                {t(title)}
                <IconButton
                    sx={{
                        height: isLandscape ? getVHByRem(2.333) : '2.333rem',
                        width: isLandscape ? getVHByRem(2.333) : '2.333rem',
                    }}
                    onClick={() => {
                        if (dialogOpen) dialogOpen(false);
                        extraCloseHandler();
                        // reset
                        resetCloseHandler();
                        playButtonAudio();
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Grid>
        </>
    );
};
